import * as consts from '../constants';
import commonFunctions from '../commonFunctions';
/**
 * This is the global application state rappresentation.
 */
export default {
    authenticationState: {
        token: '',
        username: '',
        userId: -1,
        roleId: -1,
        network: {
            id: -1
        }
    },
    networkState: {
        items: [],
        page: 1,
        itemsPerPage: 10,
        total: 0,
        codice: '',
        name: '',
        vatCode: '',
        dataInizioAttivita: null,
        dataFineAttivita: null
    },
    tariffState: {
        items: [],
        page: 1,
        itemsPerPage: 10,
        total: 0,
        label: '',
        code: '',
        showClosed: false
    },
    tariffGroupState: {
        items: [],
        page: 1,
        itemsPerPage: 10,
        total: 0,
        name: '',
        code: ''
    },
    warrantyState: {
        items: [],
        page: 1,
        itemsPerPage: 10,
        total: 0,
        companyName: '',
        warrantyName: ''
    },
    agentState: {
        items: [],
        page: 1,
        itemsPerPage: 10,
        total: 0,
        name: '',
        surname: '',
        username: '',
        roleId: consts.AUTHENTICATION.USER_ROLE.NetworkAgent
    },
    customerState: {
        items: [],
        page: 1,
        itemsPerPage: 10,
        total: 0,
        businessName: '',
        firstName: '',
        lastName: '',
        taxCode: '',
        vatCode: ''
    },
    userState: {
        items: [],
        page: 1,
        itemsPerPage: 10,
        total: 0,
        name: '',
        roleId: -1,
        surname: '',
        username: ''
    },
    contractState: {
        items: [],
        page: 1,
        itemsPerPage: 10,
        total: 0,
        agentId: -1,
        assicuratoName: '',
        clientName: '',
        contractStatus: -1,
        creationDateDa: null,
        creationDateA: null,
        expireDateDa: null,
        expireDateA: null,
        inScadenza: false,
        networkId: -1,
        productId: -1,
        proposalSequence: '',
        sequence: '',
        tariffGroupId: -1
    },
    emissionState: commonFunctions.createContract(),
    commonState: {
        blocking: 0,
        configuration: {
            conventions: [],
            subscriptions: [],
            countries: [],
            cities: [],
            counties: [],
            companies: []
        },
        static: {
            businessRoleTypes: consts.GENERIC_ENUM.businessRoleTypes.sort(function (a, b) {
                if (a.text < b.text) return -1;
                if (a.text > b.text) return 1;
                return 0;
            }),
            contractPeriodModeTypes: consts.GENERIC_ENUM.contractPeriodModeTypes,
            fractionationType: consts.GENERIC_ENUM.fractionationType,
            paymentType: consts.GENERIC_ENUM.paymentType,
            personType: consts.GENERIC_ENUM.personType,
            familyTreeTypes: consts.GENERIC_ENUM.familyTreeTypes.sort(function (a, b) {
                if (a.text < b.text) return -1;
                if (a.text > b.text) return 1;
                return 0;
            }),
            networkCategory: {
                networkMaster: consts.GENERIC_ENUM.networkCategory.networkMaster,
                networkType: consts.GENERIC_ENUM.networkCategory.networkType,
                networkGiuridicForm: consts.GENERIC_ENUM.networkCategory.networkGiuridicForm,
                networkSize: consts.GENERIC_ENUM.networkCategory.networkSize,
            },
            sex: consts.GENERIC_ENUM.sex
        }
    }
};